"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HmyCrossShard = void 0;
const tslib_1 = require("tslib");
const web3_1 = tslib_1.__importDefault(require("web3"));
const interfaces_1 = require("./interfaces");
const abi_1 = require("./abi");
class HmyCrossShard {
    constructor(params) {
        this.gasLimit = 6721900;
        this.gasPrice = 10000000000;
        this.transfer = async (value, toAddress, shardId, sendTxCallback) => {
            let fromAddress;
            if (this.walletType === interfaces_1.WALLET_TYPE.METAMASK) {
                const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
                fromAddress = accounts[0];
            }
            else {
                fromAddress = this.fromAddress;
            }
            const networkGasPrice = await this.web3.eth.getGasPrice();
            const gasPrice = Math.max(this.gasPrice, Number(networkGasPrice));
            console.log('### value', value);
            const res = await this.contract.methods.crossShardTransfer(value, toAddress, shardId).send({
                value: value,
                from: fromAddress,
                gasLimit: this.gasLimit,
                gasPrice,
            }).on('transactionHash', sendTxCallback);
            return res;
        };
        this.getBalance = async (address) => {
            let addressHex = address;
            if (!addressHex) {
                if (this.walletType === interfaces_1.WALLET_TYPE.METAMASK) {
                    const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
                    addressHex = accounts[0];
                }
                else {
                    addressHex = this.fromAddress;
                }
            }
            return this.web3.eth.getBalance(addressHex);
        };
        this.gasLimit = (params === null || params === void 0 ? void 0 : params.gasLimit) || this.gasLimit;
        this.gasPrice = (params === null || params === void 0 ? void 0 : params.gasPrice) || this.gasPrice;
        this.walletType = params.walletType;
        if (params.walletType === interfaces_1.WALLET_TYPE.INTERNAL) {
            this.web3 = new web3_1.default(params.rpcUrl);
            const hmyMasterAccount = this.web3.eth.accounts.privateKeyToAccount(params.privateKey);
            this.web3.eth.accounts.wallet.add(hmyMasterAccount);
            this.web3.eth.defaultAccount = hmyMasterAccount.address;
            this.fromAddress = hmyMasterAccount.address;
        }
        else {
            this.web3 = new web3_1.default(window.ethereum);
        }
        this.contract = new this.web3.eth.Contract(abi_1.abi, '0x00000000000000000000000000000000000000F9');
    }
}
exports.HmyCrossShard = HmyCrossShard;
